import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { MENU_SIDEBAR_TENANT } from '@/config/layout.config';
import { useMenu } from '@/hooks/useMenu';
import { Wrapper } from '@/components/layout/components/wrapper';
import { LayoutProvider } from '@/components/layout/components/context';
import { useTenantLogout } from '@/modules/tenant/hooks/useTenantAuth';
import { useModules } from '@/contexts/ModuleContext';
import { filterMenuByModules } from '@/lib/menu-filter';
import { useMemo } from 'react';

export function TenantLayout() {
  const { pathname } = useLocation();
  const { modules } = useModules();
  
  // Filter menu based on enabled modules
  const filteredMenu = useMemo(
    () => filterMenuByModules(MENU_SIDEBAR_TENANT, modules),
    [modules]
  );
  
  const { getCurrentItem } = useMenu(pathname);
  const item = getCurrentItem(filteredMenu);
  
  const tenantLogoutMutation = useTenantLogout();
  
  const handleLogout = () => {
    tenantLogoutMutation.mutate();
  };

  return (
    <>
      <Helmet>
        <title>{item?.title || 'Dealer Portal'}</title>
      </Helmet>

      <LayoutProvider
        bodyClassName="overflow-hidden"
        style={{
          '--sidebar-width': '300px',
          '--sidebar-collapsed-width': '60px',
          '--sidebar-header-height': '54px',
          '--header-height': '60px',
          '--header-height-mobile': '60px',
        } as React.CSSProperties}
      >
        <Wrapper 
          menuConfig={filteredMenu}
          portalType="tenant"
          enabledModules={modules}
          onLogout={handleLogout}
          isLogoutPending={tenantLogoutMutation.isPending}
        />
      </LayoutProvider>
    </>
  );
}
